import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../../../ReusableFIlterComponent/FilterComponent";
import {
  setSelectedAdGroupForCapturedByMultipleKeywords,
  setSelectedCampaignForCapturedByMultipleKeywords,
  setSelectedKeywordForCapturedByMultipleKeywords,
} from "../../../../../../../../../features/searchTermTabSlice";

export default function CapturedMultipleKeywordFilterItems({
  clearSelectedSearchTerm,
}: any) {
  const {
    capturedByMultipleKeywords,
    selectedCampaignForCapturedByMultipleKeywords,
    selectedAdGroupForCapturedByMultipleKeywords,
    selectedKeywordForCapturedByMultipleKeywords,
  } = useSelector((state: any) => state.searchTermTab);

  const dispatch = useDispatch();

  const [searchAdgroups, setSearchAdgroups] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [searchKeywords, setSearchKeywords] = useState("");
  const filterConfig = [
    {
      key: "CampaignForUnclassifiedST",
      name: "Campaign",
      label: "Select one or more Campaigns",
      searchTerm: searchCampaigns,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaigns(e.target.value),
      selectedOption: selectedCampaignForCapturedByMultipleKeywords,
      filterName: "campaign_name",
      data: capturedByMultipleKeywords,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedCampaignForCapturedByMultipleKeywords(updatedSelection)
        ),
      count:
        selectedCampaignForCapturedByMultipleKeywords &&
        selectedCampaignForCapturedByMultipleKeywords.length,
      colorSelected:
        selectedCampaignForCapturedByMultipleKeywords !== null &&
        selectedCampaignForCapturedByMultipleKeywords.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "AdgroupForUnclassifiedST",
      name: "Adgroup",
      label: "Select one or more Adgroups",
      searchTerm: searchAdgroups,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdgroups(e.target.value),
      selectedOption: selectedAdGroupForCapturedByMultipleKeywords,
      filterName: "adgroup_name",
      data: capturedByMultipleKeywords,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedAdGroupForCapturedByMultipleKeywords(updatedSelection)
        ),
      count:
        selectedAdGroupForCapturedByMultipleKeywords &&
        selectedAdGroupForCapturedByMultipleKeywords.length,
      colorSelected:
        selectedAdGroupForCapturedByMultipleKeywords !== null &&
        selectedAdGroupForCapturedByMultipleKeywords.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "KeywordsForUnclassifiedST",
      name: "Keyword",
      label: "Select one or more Keywords",
      searchTerm: searchKeywords,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchKeywords(e.target.value),
      selectedOption: selectedKeywordForCapturedByMultipleKeywords,
      filterName: "keyword_name",
      data: capturedByMultipleKeywords,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(
          setSelectedKeywordForCapturedByMultipleKeywords(updatedSelection)
        ),
      count:
        selectedKeywordForCapturedByMultipleKeywords &&
        selectedKeywordForCapturedByMultipleKeywords.length,
      colorSelected:
        selectedKeywordForCapturedByMultipleKeywords !== null &&
        selectedKeywordForCapturedByMultipleKeywords.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedCampaignForCapturedByMultipleKeywords([]));
    dispatch(setSelectedAdGroupForCapturedByMultipleKeywords([]));
    dispatch(setSelectedKeywordForCapturedByMultipleKeywords([]));
    clearSelectedSearchTerm(null);
    setSearchAdgroups("");
    setSearchCampaigns("");
    setSearchKeywords("");
  };

  return (
    <Box data-tracker="571" sx={{ position: "relative" }}>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
